import { useEffect, useRef, useState } from 'react'
import { isValid, formatISO } from 'date-fns'
import { TimePicker, TimePickerProps } from '@mui/x-date-pickers'
import { SimpleEventHandler, ParsableDate } from '../../types'
import { TextField, TextFieldProps } from '@mui/material'
import { nanoid } from 'nanoid'

type Props = {
  name?: string
  onChange: SimpleEventHandler<ParsableDate>
  InputProps?: Omit<TextFieldProps, 'id'>
} & Omit<TimePickerProps<any, any>, 'onChange' | 'renderInput' | 'openPicker' | 'rawValue' | 'InputProps'>

export default function InputTime(props: Props): JSX.Element {
  const { inputFormat = 'HH:mm', InputProps = {}, label, name, onChange, ...restOfProps } = props
  const [value, setValue] = useState<ParsableDate | null>(null)
  const id = useRef(nanoid())

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value as ParsableDate)
    }
  }, [props.value])

  function handleOnChange(date: any): void {
    setValue(date)
    if (date === null || isValid(date)) {
      onChange({ target: { name, value: date ? formatISO(date) : null } })
    }
  }

  return (
    <TimePicker
      {...restOfProps}
      inputFormat={inputFormat}
      label={label}
      onChange={handleOnChange}
      renderInput={(params: any) => (
        <TextField {...params} {...InputProps} id={id.current} size={InputProps?.size || 'small'} />
      )}
      value={value}
    />
  )
}
